import {  sendApi } from ".";
import { T_Video } from "../model/videoModel";

async function videoList(data?: any) {

    const response = await sendApi({
      method: "post",
      url: "/video/list",
      data: {
        ...data,
      },
    });

    return response;
  }

async function videoCreate(data1?:T_Video){

  const response = await sendApi({
    method: "post",
    url: "/video/insert",
    data: {
      ...data1,
    },
  });

  return response;
}  
async function videoEdit(data1?:T_Video){

  const response = await sendApi({
    method: "post",
    url: "/video/update",
    data: {
      ...data1,
    },
  });

  return response;
}  
async function videoDelete(data1?:T_Video){

  console.log("errordata:",data1);
  
  const response = await sendApi({
    method: "post",
    url: "/video/delete",
    data: {
      ...data1,
    },
  });

  return response;
}  

const error = {
    videoList,
    videoCreate,
    videoEdit,
    videoDelete,
  };
  export default error;

